import { DEFAULT_GRIND, DEFAULT_WEIGHT, formatMoney, type Product, unitPrice } from '@c214/shared';
import { Link } from 'react-router-dom';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
import { cn } from '../../lib/utils';
import { useCart, useFavorites } from '../../providers';
import { PackArt } from '../product/PackArt';
import { Button } from '../ui/button';
import { HeartButton } from '../ui/heart-button';
import { TasteBar } from '../ui/taste-bar';

export function ProductRow({ product }: { product: Product }) {
  const cart = useCart();
  const favorites = useFavorites();
  const { ref, revealed } = useRevealOnScroll<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={cn(
        'flex flex-wrap items-center gap-4 border-b border-line-soft py-4 transition-all duration-500',
        revealed ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0',
      )}
    >
      <Link to={`/product/${product.id}`} className="w-[52px] shrink-0">
        <PackArt variant="mini" name={product.name} className="h-[66px] w-[52px]" />
      </Link>

      <div className="min-w-40 flex-[2]">
        <Link
          to={`/product/${product.id}`}
          className="text-[20px] font-bold tracking-[-0.03em] text-ink no-underline"
        >
          {product.name}
        </Link>
        <p className="mono-label mt-1 text-[10px]">
          {product.region} · ОБСМАЖЕНО {product.roastedAt.slice(8)}.{product.roastedAt.slice(5, 7)}{' '}
          · ВІДПРАВКА {product.shipsAt.slice(8)}.{product.shipsAt.slice(5, 7)}
        </p>
      </div>

      <p className="min-w-[120px] flex-[1.4] text-[14px] text-muted">{product.notes}</p>

      <div className="w-[84px] shrink-0 space-y-1">
        <TasteBar label="Кислинка" value={product.acid} />
        <TasteBar label="Гірчинка" value={product.bitter} />
        <TasteBar label="Тіло" value={product.body} />
        <p className="font-mono text-[10px] text-muted-2">{product.score}</p>
      </div>

      <span className="w-[84px] shrink-0 text-[19px] font-bold text-ink">
        {formatMoney(unitPrice(product.price, DEFAULT_WEIGHT))}
      </span>

      <div className="w-10 shrink-0">
        <HeartButton
          active={favorites.has(product.id)}
          onToggle={() => favorites.toggle(product.id)}
        />
      </div>

      <Button
        variant="secondary"
        className="w-[112px] shrink-0 px-3"
        onClick={() =>
          cart.add({
            productId: product.id,
            name: product.name,
            weight: DEFAULT_WEIGHT,
            grind: DEFAULT_GRIND,
            unitPrice: unitPrice(product.price, DEFAULT_WEIGHT),
            qty: 1,
          })
        }
      >
        + У КОШИК
      </Button>
    </div>
  );
}
